<template>
    <div class="form-group">
        <label :for="name">
            <span v-html="label" :class="{'text-white': invert}"></span>
            <span class="text-red font-bold" v-if="required">*</span>
        </label>
        <slot></slot>
        <div class="bg-red text-white font-bold rounded px-4 py-2 mt-3" role="alert" v-if="useAlertStyle && hasError(name)">
            {{getError(name)}}
        </div>
        <div class="help-text text-red" v-else-if="hasError(name)" v-html="getError(name)"></div>
        <span class="help-text text-grey-dark" v-if="!hasError(name) && help.length > 0" v-html="help"></span>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        props: {
            name: String,
            label: String,
            required: {
                type: Boolean,
                default: false,
            },
            invert: {
                type: Boolean,
                default: false,
            },
            help: {
                type: String,
                default: '',
            },
            useAlertStyle: {
                default: false
            }
        },
        methods: {
            hasError(name) {
                return this.$store.getters.hasError(name)
            },
            getError(name) {
                return this.$store.getters.getError(name)
            }
        }

    }
</script>